module.exports = __webpack_public_path__ + "img/barlogo.a9e8ccd7.webp";